import * as types from "./actionTypes";
import JsonApi from "../api/jsonApi";
import {setBathroomVisualizerPresets} from "./actionFunctions";
import {loaderDisable} from "../bvcomponents/ui/loaderView";

export const setStaticCanvasImage = (staticCanvasImage) => ({
  type: types.SET_STATIC_CANVAS_IMAGE,
  payload: {staticCanvasImage}
});


export const getBvPresets = (room, forVisualizer, withLoader = false) => {
  return async (dispatch, getState) => {
    const {allVisualizersPresets, requestedVisualizerPresets} = getState().bathroomVisualizerState;
    if (allVisualizersPresets[forVisualizer] || requestedVisualizerPresets.includes(forVisualizer)) {
      return;
    }
    dispatch({
      type: types.REQUEST_BV_PRESETS,
      payload: forVisualizer
    });
    // Always store a result (even an empty one) for forVisualizer: LookRoomsMain shows a spinner
    // while any requested visualizer has no entry in allVisualizersPresets, so a failed or empty
    // response must still resolve to [] instead of leaving the entry missing (endless loader).
    const setEmptyPresets = () => dispatch(setBathroomVisualizerPresets([], forVisualizer));
    return JsonApi.getDisplayRoom(room)
      .then(responseData => {
        // console.log('getBvPresets:', responseData);
        if (!responseData?.data || responseData.data.error) {
          setEmptyPresets();
          console.error("get bvPresets error: No response data received", room, forVisualizer);
          return [];
        }
        const parsed = typeof responseData.data === "string" ? JSON.parse(responseData.data) : responseData.data;
        const bvPresets = Array.isArray(parsed) ? parsed : [];
        console.log("bvPresets", room, forVisualizer, bvPresets);
        dispatch(setBathroomVisualizerPresets(bvPresets, forVisualizer));
        return bvPresets
      })
      .catch((error) => {
        setEmptyPresets();
        if (withLoader) {
          loaderDisable();
        }
        console.log('getDisplayRoom', error);
        return [];
      });
  }
};
